import { useField } from 'remix-validated-form'
import { useState } from 'react'
import type { ChangeEvent } from 'react'
import type { TextFieldProps } from '~/components/shared';
import { TextField } from '~/components/shared'
import { AppConfig } from '~/AppConfig';

interface TextInputProps extends TextFieldProps {
  label: string
  labelClass?: string
  id?: string
  name: string
  value?: string
  disabled?: boolean
  readOnly?: boolean
  optional?: boolean
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
}

export default function TextInput_v2(props: TextInputProps) {
  const {
    label,
    optional,
    id,
    name,
    disabled,
    value: defaultValue,
    onChange,
    readOnly,
    helperText,
    ...restProps
  } = props
  const [value, setValue] = useState(defaultValue ?? '')
  const { error, getInputProps } = useField(name, {
    validationBehavior: AppConfig.InputValidationBehavior
  })

  let inputValue, onChangeHandler

  const isControlledInput = typeof onChange === 'function'

  if (isControlledInput) {
    // let the parent control onChange and value
    inputValue = defaultValue
    onChangeHandler = onChange
  } else {
    // let the component handle internal value
    inputValue = value
    onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => setValue(e.target.value)
  }
  return (
    <TextField
      {...getInputProps({
        label: label || '',
        optional: optional,
        id: id,
        disabled: disabled,
        readOnly: readOnly,
        value: inputValue,
        onChange: onChangeHandler,
        error: Boolean(error),
        helperText: error || helperText || '',
        ...restProps,
      })}
    />
  )
}
